module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "pl-17-16"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg16_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figure-aligncenter-indent"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg17_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("GROWTH AND PRODUCTION")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The cotton plant is a member of the same family as the hibiscus and hollyhock. It grows most successfully in warm climates where rain or irrigation can provide sufficient water when needed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The plant blooms about one hundred days after planting. The petals drop off after forty-eight hours, leaving the boll, or seed pod, where the fibers form. Fifty to eighty days later the pod bursts open, and the soft cotton fibers are ready for picking. The modern cotton plant is a miracle of genetic engineering by “seed breeders.” The size, amount, location on the plant, and maturity date of the cotton is controlled by genetics designed into the plant. Also, the length, strength, and fineness of the fiber are genetically controlled.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Before picking, the plants are often sprayed with defoliants. These sprays cause the leaves to shrivel and fall off. As the cotton bolls mature and open, the cotton fibers appear as fluffy white puffs.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("Cotton Picking and Stripping")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Cotton is picked by machine, using either a picker or a stripper. A picker pulls the fibers from the open bolls and is best used on fields with lush growth and high yield. It picks two to four rows at a time and can go over the field several times if needed. Strippers pull the entire boll from the plant, and are most effective on fields with low yields and low-growing plants. They pull from two to four rows simultaneously and go over a field only once.")]), _vm._v(" "), _c('p', {
    staticClass: "figure-aligncenter-indent"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg17_2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "pl-18-17"
    }
  }), _vm._v("Hand picking was once the only way to harvest cotton. It produced the most uniform and best quality fiber. However, because of high labor costs and inadequate labor available, the use of hand pickers in the United States is now nonexistent. Seed breeders have made the cotton plant machine harvestable.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("Cotton Ginning")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After the cotton has been picked, it is taken to the gin. Here the fiber, called cotton lint, is separated from the seed. Today’s gins, except for size, are principally the same as the first saw gin developed by Eli Whitney in 1793.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Not only is the lint separated from the seed in the gin, but foreign matter such as dirt, twigs, leaves, and parts of the boll are also removed. The seeds are a valuable byproduct of the cotton industry. Cattle feed and cottonseed oil are produced from these seeds. The fibers are packed into large bales weighing about five-hundred pounds.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("Fiber Classification")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Fiber class is determined by removing samples of the fibers from the bales. Classification is made using the following factors: staple length, fiber grade, and character. "), _c('i', [_vm._v("Staple length")]), _vm._v(" is the length of the lint (fiber) and is often determined by the variety of the cotton plant. "), _c('i', [_vm._v("Fiber grade")]), _vm._v(" depends on color, amount of foreign "), _c('a', {
    attrs: {
      "id": "pl-19-18"
    }
  }), _vm._v("matter present, and ginning preparation. The color can vary from white to gray to yellow. Mechanically picked fibers can have a lot of foreign matter, depending on picking conditions and weather. In mechanical harvesting, spotted or tinged cotton results because bolls that have been opened for some time are mixed with newly opened bolls. Hand-picked cotton, on the other hand, has very little foreign matter because the cotton is harvested at the time when the boll is mature. Fiber grade involves fiber fineness, color, and foreign matter. "), _c('i', [_vm._v("Fiber character")]), _vm._v(" includes fiber strength, uniformity, cohesiveness, pliability, elastic recovery, fineness, and resilience. When all this information has been gathered, the final quality of the cotton is established and a price is determined. Next, the fiber is baled and shipped to manufacturers of yarns and fabrics.")]), _vm._v(" "), _c('p', {
    staticClass: "figure-aligncenter-indent"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg18_2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figure-aligncenter-indent"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg18_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("COTTON PROCESSING")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To turn fibers into fabrics, the fibers are first converted into yarns, which are then woven into fabrics.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Once the bales arrive at the mill, the fibers from several different bales are combined. Cotton is opened in large opening and cleaning hoppers. Thin layers of fibers from different bales are fed into the blending machine.")]), _vm._v(" "), _c('p', {
    staticClass: "figure-aligncenter-indent"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg19_3.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("These machines loosen and separate the tufts of closely packed fibers and remove stems, leaves, seed fragments, dirt, and other heavy impurities. This makes a uniform, well-blended mix. After several stages of opening and cleaning, the cotton lint is transported by air flow through large ductwork systems to “chutes” which uniformly feed the raw stock (lint) to the cards.")]), _vm._v(" "), _c('p', {
    staticClass: "figure-aligncenter-indent"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg19_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figure-aligncenter-indent"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg19_2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("Carding")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Carding continues the cleaning process, removing fibers too short for yarns, and separating and straightening the fibers so they lay parallel to each other. These fibers are then spread into a thin, uniform web. The web moves into a funnel-shaped device (trumpet) where it is gathered into a rope-like mass and formed into the "), _c('i', [_vm._v("card sliver")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "figure-aligncenter-indent"
  }, [_c('a', {
    attrs: {
      "id": "pl-20-19"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg20_3.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figure-aligncenter-indent"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg20_4.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Depending on the quality of yarn being made, the sliver either goes to the drawing machine or the combing machine. Fine-quality cottons require yarns to be combed in addition to carding. The card sliver goes through the breaker-drawing step and then the combing operation.")]), _vm._v(" "), _c('p', {
    staticClass: "figure-aligncenter-indent"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg20_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figure-aligncenter-indent"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg20_2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("Combing")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Combing is used for high-quality yarns of great evenness, smoothness, fineness, and strength. This operation combines several card slivers which are drawn into the comber and, once again, spread into a web. The fibers continue to be cleaned and straightened as the web is formed. Short fibers and all residual non-lint material are removed. This combed sliver is used to make high-quality yarns.")]), _vm._v(" "), _c('p', {
    staticClass: "figure-aligncenter-indent"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg20_5.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "pl-21-20"
    }
  }), _vm._v("Drawing")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Drawing follows either carding or combing, depending on the quality of yarn desired. Several strands of sliver (typically eight to ten) from different carding machines are combined and conveyed to the drawing machine, where they are pulled together and drawn out into a new sliver no larger than one of the original single slivers. The loose, rope-like strand of fibers resulting from this process is called "), _c('i', [_vm._v("drawn sliver")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "figure-aligncenter-indent"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg21_2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Today’s mills use either two-process or three-process drawing, which describes the number of such processes of drawing that the sliver undergoes. The purpose of drawing is to make yarn more uniform by combing and elongating multiple slivers, thus eliminating the randomly occurring defects. After three processes of combining and drawing ten ends, random defects are virtually eliminated.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After drawing, rotor yarns go directly to the spinning frame. Ring spun yarns, however, must undergo an additional intermediate step between sliver and yarn called roving.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("Roving")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The drawn sliver is taken to the roving frame, where it is further drawn out until it measures from ⅛ to "), _c('sup', [_vm._v("3")]), _vm._v("/"), _c('sub', [_vm._v("16")]), _vm._v(" inches in diameter. As the roving strand is ready to leave the roving frame, a slight twist is imparted to hold the fibers together.")]), _vm._v(" "), _c('p', {
    staticClass: "figure-aligncenter-indent"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg21_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figure-aligncenter-indent"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg21_3.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "pl-22-21"
    }
  }), _vm._v("Spinning")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The final process in making the yarns is the actual spinning operation. The spinning frame converts the roving to a spun single yarn.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Spun yarns are composed of short lengths of fiber twisted or spun to hold them together. These short fibers are called staple fibers. The fibers are first processed to make them parallel, then alternately pulled and twisted. Other types of yarns include long staple (wool, linen, and acrylic) and continuous filament (acetate, nylon, silk, polyester, etc.).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Over the past twenty years cotton processing has changed. The two most widely used processes for making cotton yarn are "), _c('i', [_vm._v("ring spinning")]), _vm._v(" and "), _c('i', [_vm._v("rotor spinning")]), _vm._v(". Ring spinning is used for high-quality, smaller yarns (shirtings); rotor spinning is typically used for larger yarns (denim). Most combed yarns are ring spun.")]), _vm._v(" "), _c('p', {
    staticClass: "figure-aligncenter-indent"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg22_2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figure-aligncenter-indent"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg22_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In ring spinning the roving is further drawn out to the desired diameter of the final yarn. The high-twist characteristic of spun yarns is added during this operation. This is where the term ring spinning comes in. In ring spinning, the drawn-out roving is guided downward through a small inverted U-shaped device called a traveler.")]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }, [_c('i', [_vm._v("The purpose of drawing is to make yarn more uniform by combing and elongating multiple slivers, thus eliminating the randomly occurring defects.")])]), _vm._v(" "), _c('p', {
    staticClass: "figure-aligncenter-indent"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg23_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The completed yarn is wound onto a spindle which rotates up to 13,000 revolutions per minute. If the speed of the traveler is too great, or if the edges are rough, the result will be frayed or hairy yarns, which will make fuzzy fabric and will cause pilling in cotton/polyester blends. The traveler moves around the ring at a rate of between 4,000 and 12,000 revolutions per minute. As the spindle revolves to wind the yarn, the yarn passes through the traveler, which carries it around the ring. This process gives the desired amount of twist and creates a single yarn.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In rotor spinning, the sliver is fed to a combing roll, which removes more or less individual fibers from the sliver and propels them into a rotor. This is very similar to a cotton candy machine, but the rotors are small and run at very high speed (20,000–60,000+ rpm). The "), _c('a', {
    attrs: {
      "id": "pl-23-22"
    }
  }), _vm._v("rotor yarn is then pulled from the rotor. This too produces a single yarn. In some cases fine single yarns are combined into pairs called 2-ply yarns. The term "), _c('i', [_vm._v("ply")]), _vm._v(" indicates the number of single yarns twisted together to form a plied yarn, or the number of plied yarns twisted together to form cord. Plying is the twisting together of two or more single yarns or ply yarns to form, respectively, ply yarn or cord.")]), _vm._v(" "), _c('p', {
    staticClass: "figure-aligncenter-indent"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg23_2.jpg"
    }
  })]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "id": "pl-24-23"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("Winding")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Yarn from the spinning frame is next wound onto large spools or packages in a process called "), _c('i', [_vm._v("winding")]), _vm._v(". These spools or packages are now used in weaving, knitting, and other operations. In some cases, packages of yarn may be dyed prior to knitting or weaving. This allows colored patterns to be produced in the fabric.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("Weaving")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Woven fabrics consist of two sets of yarns interlaced at right angles in established sequences. The yarns that run parallel to the selvage, or the length of the bolt of fabric, are called the warp yarns; those running the crosswise direction are called filling yarns.")]), _vm._v(" "), _c('p', {
    staticClass: "figure-aligncenter-indent"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg24_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "pl-25-24"
    }
  }), _vm._v("Fabrics are identified by their construction. For example, 68 x 68 printcloth has 68 single-ply warp yarns per linear inch and 68 single-ply filling yarns per linear inch.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Yarns can be loosely or tightly woven. When the warp yarns equal the filling yarns in number per linear inch it is called a balanced (or square) fabric construction.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("While several factors contribute to the quality of a fabric (the type of fibers used to make the yarn, the process taken to create and print the fabric, and the intended use of the fabric), "), _c('i', [_vm._v("thread count")]), _vm._v(" is a very useful way to describe a fabric. Determining the number of yarns per inch in both the warp and filling directions gives some information concerning how close the yarns are in each direction, as well as information on the appearance, flexibility, compactness, density, and performance of a woven fabric.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For many quilters the preferred yarn count is 68 x 68. 60 x 60 is beefier, but the lower yarn count uses fatter yarns to fill in the spaces. This makes a heavier, coarser fabric that ravels more easily, making it somewhat more difficult to work with. A smooth longer fiber makes finer yarns and thus finer cloth. In terms of appearance, the higher-count cloth provides sharper images of prints. The quality of materials we put into our quilts directly affects the final outcome.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The fabrics used in quiltmaking are mainly plain weave fabrics. Plain weave is the simplest and most used form of weaving. It consists of alternate interlacing of warp and filling yarns. These fabrics are reversible except for special finishes, prints, or other surface designs that give a right side to the fabric.")]), _vm._v(" "), _c('p', {
    staticClass: "figure-aligncenter-indent"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg25_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Cotton sateen fabric is a durable cotton fabric with a satin weave. Instead of interlacing alternate yarns, the warp yarns “float” over or under a predetermined number of filling yarns. These long floats give a lustrous look to the fabric.")]), _vm._v(" "), _c('p', {
    staticClass: "figure-aligncenter-indent"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg25_2.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39f204b8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/09_chaptertitle3.vue
// module id = 75
// module chunks = 0